// Build-time feature flags (VITE_* are inlined; never put secrets here).
const on = (v: string | undefined) => v === "1" || v === "true";

// Client-side PDF statement import (feature 001). Off by default until complete.
export const FEATURE_STATEMENT_PDF = on(import.meta.env.VITE_FEATURE_STATEMENT_PDF);
